module.exports = __webpack_public_path__ + "img/Doctor.3422b4b8.png";